import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const DoucmentEnergytabtwo = () => {
     const location = useLocation();
        const searchParams = new URLSearchParams(location.search);
        const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "tab1");
    
        useEffect(() => {
            const tabParam = searchParams.get("tab");
            if (tabParam) {
                setActiveTab(tabParam);
            }
        }, [location.search]); // Update tab when URL changes
    
    const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreClick = () => {
        navigate("/carrerspage"); // Replace with the actual route you want to navigate to
    };

    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        const tabInterval = setInterval(() => {
            // setActiveTab((prevTab) => {
            //     const nextTabNum = parseInt(prevTab.replace("tab", "")) % 3 + 1; // 9 tabs in total
            //     return `tab${nextTabNum}`;
            // });
        }, 3000); // Change tab every 3 seconds

        // Clear interval when component unmounts
        return () => clearInterval(tabInterval);
    }, []);

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            flexDirection: "row",
            width: "98%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {
            // width:"400px",
            // height:"400px",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav

        tabButton: {
            padding: "19px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        }
    };
    const tabContent = {
        tab1: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li> The Payment Card Industry (PCI) Standards are a set of security requirements designed to protect cardholder data and payment transactions. These standards ensure secure handling, processing, and transmission of payment information across different industries, including energy and infrastructure.</li><b> The PCI standards mentioned in the image include: </b> <br><br>1.	PCI DSS v4.0 (Payment Card Industry Data Security Standard) <ul><li>Ensures secure payment transactions for utility bills, toll payments, and </li><li>Protects customer payment data from fraud and cyberattacks.</li></ul> 2.	PCI PTS (PIN Transaction Security) <ul><li>Focuses on securing POS (Point-of-Sale) terminals and kiosk-based payment systems.</li><li>Ensures secure encryption for PIN-based transactions.</li></ul> 3.	PCI PA-DSS (Payment Application Data Security Standard) <ul><li>Ensures compliance for billing software and smart grid payment applications. </li><li>Validates secure payment software development. </li></ul> 4.	PCI SSF (Software Security Framework) <ul><li>Focuses on securing digital payment solutions used in energy and infrastructure sectors. </li><li>Replaces PA-DSS with modern software security practices.</li></ul> " },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The Payment Card Industry Security Standards Council (PCI SSC) is the global regulatory body responsible for defining and maintaining PCI security standards.</li><ul><li>PCI SSC was founded by major payment brands (Visa, Mastercard, American Express, Discover, and JCB).</li><li>Compliance is enforced by banks, financial institutions, and regulatory authorities handling payment processing.</li><li>In India, the Reserve Bank of India (RBI) and CERT-In also oversee payment security compliance.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: " These PCI standards apply to any organization that handles card-based transactions, including those in the Energy & Infrastructure sector. <br><br><b> Key impacted entities include:</b><ul><li>Utility service providers (electricity, gas, water companies) processing online bill payments.</li><li>Toll collection systems using POS terminals, RFID-based payments, and digital wallets.</li><li>Smart grid operators handling customer payments for prepaid energy meters.</li><li>Renewable Energy Companies – Solar farms, wind power plants, and hybrid energy projects connected to the grid.</li><li>Smart Grid Operators – Companies managing IoT-based grid automation, power storage, and demand response. </li><li>Banks and financial service providers facilitating payments in the energy sector.</li></ul>" },
            { id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 10px;">
        <span style="font-size: 18px; display: inline-block; text-align: top;">✅</span>
        <span>Yes, compliance with these regulations is mandatory for all applicable entities.</span>
    </li></ul><ul> <li> Power utilities and grid operators must implement security controls as per CEA mandates. </li><li> Non-compliance can lead to financial penalties, regulatory action, or operational restrictions.</li><li>Government projects, tenders, and renewable energy firms must ensure compliance to receive funding and approvals.</li><li>Entities must integrate cybersecurity measures across IT and OT systems to protect critical infrastructure.</li></ul>` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> The frequency of audits depends on the organization’s transaction volume and security risk: </li><ul><li>Large Enterprises & Payment Service Providers (processing over 6 million transactions annually) → Annual PCI DSS Audit by a Qualified Security Assessor (QSA).</li><li>Mid-Sized Businesses & Utility Firms → Self-Assessment Questionnaire (SAQ) submission annually.</li><li>Kiosk-Based Payment Operators → Quarterly vulnerability scans and security checks. </li><li> Incident-Based Audits → Required if a data breach occurs. </li><li>Failure to conduct regular audits can result in payment processing restrictions or increased transaction fees from banks.</li></ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;'>*</span>Each PCI standard has specific requirements. Below are key security mandates across PCI DSS, PCI PTS, PCI PA-DSS, and PCI SSF: <br><br>A. PCI DSS (Secure Payment Transactions for Energy & Infrastructure)<ul><li>Implement strong encryption for payment data </li><li>Use firewalls & intrusion detection systems.</li><li>Regular security patching & updates for payment systems. </li><li>Restrict access to sensitive payment information.</li><li>Conduct annual security audits & penetration testing. </li></ul> B. PCI PTS (Securing POS & Kiosk-Based Payment Systems) <ul><li>Ensure tamper-proof PIN entry devices.</li><li>Secure RFID-based toll payment systems.</li><li>Implement secure card authentication & tokenization.</li></ul>C. PCI PA-DSS (Payment Application Compliance)<ul><li>Ensure smart grid billing apps comply with secure coding guidelines.</li><li>Prevent storage of sensitive cardholder data.</li><li>Secure digital wallets for infrastructure payments.</li></ul>D. PCI SSF (Software Security Framework) <ul><li>Apply secure-by-design principles in payment software development.</li><li>Monitor real-time fraud detection.</li><li>Implement multi-factor authentication for high-risk transactions.</li></ul>" },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `The official PCI standards can be accessed from: <br><br>
              📌 Official Source:
              <ul><li>
             	PCI Security Standards Council (PCI SSC): https://www.pcisecuritystandards.org </li>
 
                <li>	RBI Guidelines on Payment Security: https://www.rbi.org.in</li>
           
                <li>	CERT-In Cybersecurity Regulations for Payment Systems: https://www.cert-in.org.in</li>

        
                <li>	Indian Banks Association (IBA) Payment Security Frameworks: https://www.iba.org.in </li></ul>
           
                Organizations handling utility payments, toll collections, or smart grid transactions must ensure compliance by working with PCI-certified assessors (QSAs) and payment security firms.
                `
            },
            {
                id: 8,
                title: " 	What is the implication for the Indian Energy & Infrastructure sector?",
                description: `For India’s Energy & Infrastructure sector, PCI compliance has significant security and regulatory implications:
<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
    <span>✅</span> <span>Mandatory for Digital Payments in Utilities & Infrastructure</span>
</div>
<ul>
    <li>Power, water, and gas companies must secure billing transactions against fraud.</li>
</ul>

<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
    <span>✅</span> <span>Securing Toll Collection & Smart City Payments</span>
</div>
<ul>
    <li>Electronic toll collection (ETC) and RFID-based transit payments must follow PCI DSS standards.</li>
</ul>

<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
    <span>✅</span> <span>Protection Against Cyber Fraud & Data Breaches</span>
</div>
<ul>
    <li>Unauthorized access to smart grid payments can lead to financial and operational risks.</li>
    <li>Compliance reduces financial fraud, cyberattacks, and reputational risks.</li>
</ul>

<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
    <span>✅</span> <span>Integration with India's Digital Payments & Fintech Growth</span>
</div>
<ul>
    <li>Energy sector fintech platforms must comply with PCI SSF for secure software development.</li>
    <li>Digital payment adoption for prepaid energy meters & smart grids needs strong PCI security measures.</li>
</ul>

<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
    <span>✅</span> <span>Avoiding Legal & Financial Penalties for Non-Compliance</span>
</div>
<ul>
    <li>Non-compliant organizations face fines, transaction bans, and loss of business partnerships with banks.</li>
</ul>
  `
            },
           

        ],
        tab2: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li> The listed ISO/IEC standards are internationally recognized frameworks for cybersecurity, IT/OT (Operational Technology) security, and asset management in energy, utilities, and infrastructure sectors. These standards provide best practices to protect critical infrastructure, industrial control systems (ICS), smart grids, and IT networks from cyber threats.</li><ul><li> ISO/IEC 27001 – Information Security Management System (ISMS) </li><li>Defines best practices for managing information security risks.</li><li>Helps organizations implement confidentiality, integrity, and availability (CIA) controls for data protection.</li></ul><li> ISO/IEC 27019 – Cybersecurity for Energy & Utility Control Systems (SCADA, ICS, and IoT systems)</li><ul><li>Specifically focuses on cybersecurity in power grids, oil & gas, and industrial control systems.</li><li>Secures SCADA (Supervisory Control & Data Acquisition), IoT-enabled grids, and automation technologies.</li></ul><li>ISO/IEC 62443 – Industrial Automation & Control System (IACS) Cybersecurity </li><ul><li>Standard for securing Industrial Control Systems (ICS) in energy, manufacturing, and process industries. </li><li> Covers network segmentation, risk assessment, and cybersecurity resilience for OT environments.</li></ul> <li>ISO/SAE 21434 – Cybersecurity for Automotive & Smart Mobility </li><ul><li>Provides cybersecurity framework for connected vehicles, EV charging networks, and smart transportation.</li></ul><li>ISO 55001 – Asset Management for Infrastructure & Utilities</li><ul><li>Establishes best practices for managing physical and digital infrastructure assets.</li><li>Helps in lifecycle risk management of assets like power grids, pipelines, and smart city networks.</li></ul></ul>" },
            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The International Organization for Standardization (ISO) and International Electrotechnical Commission (IEC) develop and maintain these standards.</li><ul><li> Bureau of Indian Standards (BIS) – Aligns ISO standards with national cybersecurity frameworks.</li><li>Central Electricity Authority (CEA) – Mandates ISO 27019 & ISO 62443 for power sector cybersecurity. </li><li> Indian Computer Emergency Response Team (CERT-In) – Enforces cybersecurity audits for critical infrastructure.</li><li>National Critical Information Infrastructure Protection Centre (NCIIPC) – Secures Industrial Control Systems (ICS) and energy networks.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: " These cybersecurity standards apply to organizations handling critical infrastructure, energy grids, and industrial automation systems. <br><br><b>Key impacted entities include:</b> <ul><li>Power utilities (generation, transmission, and distribution companies).</li><li>Oil & gas refineries, pipelines, and energy storage facilities.</li><li>Smart grid operators and renewable energy firms.</li><li>Industrial automation companies managing SCADA & ICS systems.</li><li> Transportation & infrastructure companies (rail, metro, highways, toll systems).</li><li>Government agencies managing smart city projects and infrastructure assets.</li><li>Electric vehicle (EV) infrastructure providers and automotive manufacturers.</li></ul>" },
            { id: 4, title: "Is compliance mandatory?", description: `<div style="display: flex; align-items: center; gap: 8px;">
            <span>✅</span> 
            <span>Yes, compliance is mandatory for critical sectors like energy, utilities, and industrial automation.</span>
            </div>

            <ul><li> CEA Cybersecurity Guidelines (2021) mandate ISO 27019 & ISO 62443 compliance for power sector security.</li><li>CERT-In Cybersecurity Directions (2022) enforce ISO 27001-based security frameworks for critical infrastructure.</li></ul>Non-compliance can lead to regulatory penalties, legal actions, and cybersecurity risks.` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Annual IT/OT cybersecurity audits are required for compliance with ISO 27001, ISO 27019, and ISO 62443.<br> Quarterly vulnerability assessments and penetration testing (VAPT) for high-risk OT environments. </li><li>Real-time security monitoring and compliance reporting to CEA, CERT-In, and NCIIPC.<br>Infrastructure asset audits (ISO 55001) must be conducted periodically to assess risk exposure & resilience.</li></ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;'>*</span>Each standard has specific cybersecurity requirements. Below are the key mandates: <br><br>A. ISO/IEC 27001 – Information Security Management System (ISMS)<ul><li> Implement risk-based security controls to protect IT & OT assets.</li><li>Define cybersecurity governance framework with clear roles & responsibilities.</li><li>Regular security awareness training & incident response planning.</li></ul> B. ISO/IEC 27019 – Cybersecurity for Energy & Utility Control Systems <ul><li>Secure SCADA & ICS networks from cyberattacks.</li><li>Implement role-based access control (RBAC) & multi-factor authentication (MFA).</li><li>Conduct penetration testing & vulnerability assessments for energy systems.</li></ul>C. ISO/IEC 62443 – Industrial Automation & Control Systems (IACS) Cybersecurity <ul><li>Apply network segmentation & Zero Trust Security to industrial networks.</li><li>Secure remote access to OT systems with strong encryption.</li><li>Implement real-time anomaly detection & threat intelligence.</li></ul>D. ISO/SAE 21434 – Cybersecurity for Automotive & Smart Mobility<ul><li>Secure EV charging infrastructure & vehicle telematics from cyber threats.</li><li>Implement end-to-end encryption for vehicle-to-grid (V2G) communications.</li></ul>E. ISO 55001 – Asset Management for Infrastructure & Utilities <ul><li>Implement predictive maintenance & risk-based asset management. </li><li>  Ensure data integrity & security of infrastructure control systems.</li></ul>" },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `These standards can be accessed from: 
             <ul><li> ISO (International Organization for Standardization): https://www.iso.org</li>
                <ul><li>  IEC (International Electrotechnical Commission): https://www.iec.ch</li>
 
                <li>   Bureau of Indian Standards (BIS) – India’s adoption of ISO standards: https://www.bis.gov.in</li>
      
        
                <li>  CERT-In Guidelines for Critical Infrastructure Security: https://www.cert-in.org.in</li>
           
                <li>  CEA Cybersecurity Guidelines for Power Sector (2021): https://cea.nic.in</li>
           
                <li> Organizations should consult cybersecurity auditors or compliance experts for implementation and certification.</li></ul>
               
                `
            },
            {
                id: 8,
                title: " 	What is the implication for the Indian Energy & Infrastructure sector?",
                description: `For India’s energy and infrastructure companies, these cybersecurity standards have significant operational and security implications:  <br><br>
      
<div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span>Stronger Cyber Resilience for Critical Infrastructure</span>
</div>
        <ul><li>Energy grids, industrial control systems, and infrastructure assets will be protected from cyberattacks.</li></ul>
 <div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span> Mandatory for Government & Private Sector Contracts</span>
</div>
        
         
       <ul><li> Smart city projects, renewable energy firms, and industrial automation providers must comply with ISO standards.</li></ul>
           <div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span>Prevention of Cyber Threats to Power Grids & SCADA Networks  </span>
</div>
         
         <div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span> Protects against ransomware attacks, insider threats, and state-sponsored cyber espionage.</span>
</div>
        
         
         <ul><li>
        Compliance with National & Global Security Frameworks</li>
        <li>
         Aligns with NCIIPC, CERT-In, RBI, and international cybersecurity policies.</li></ul>
         
        

         <div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span>  Financial & Legal Risks for Non-Compliance</span>
</div>
         <ul><li>
         Regulatory penalties, loss of business licenses, and cyberattack liabilities for non-compliant organizations.</li></ul>
         
        
         <div style="display: flex; align-items: center; gap: 8px;">
    <span>✅</span> 
    <span>   Better Integration with Smart Grids, IoT, and AI-Driven Infrastructure</span>
</div>
         
         <br>
         Ensures secure deployment of AI-driven energy management systems.
                `
            },
           

        ],
       
       
       
    };

    const [toggle, setToggle] = useState(null);

    const updateToggle = (id) => {
        setToggle(toggle === id ? null : id);
    };
    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>(PCI & ISO)  </span>Standards FAQ's
            </h1>

            <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="aeroducoment-data">
                {/* Tab Navigation */}
                <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="eneg-nav-data-tab">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                     className="tab-button-width"
                     onMouseEnter={(e) => {
                        if (activeTab !== "tab1") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab1") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                       PCI Standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab2") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab2") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                   >
                        Cybersecurity & IT/OT Security Standards


                    </button>
                   
                    
                    
                </div>

                {/* Tab Content */}
                <div
                    style={{
                        ...styles.card,
                        ...(window.innerWidth <= 768 ? styles.mobileCard : {}),
                        // height: toggle ? "auto" : "450px", 
                        // maxHeight: toggle ? "870px" : "450px", 
                        transition: "max-height 0.3s ease", // Transition for smooth expansion
                        overflowY: "auto", // Enable vertical scrolling when content overflows
                        paddingTop: "20px", // Padding to prevent content from sticking to the top
                    }}
                    className="aero-card-data"
                 >
                    <div className="list-tab data-list-tab" style={{ width: "100%", padding: 0,  gap: "10px", flexWrap: "wrap" }}>
                        {tabContent[activeTab].map(({ id, title, description }, index) => (
                             <div
                             key={id}
                             className="mb-3"
                             style={{
                                 width: "100%",
                                //  flex: "1 1 calc(50% - 10px)",
                                flexWrap: "wrap",
                                //  marginTop:
                                //      window.innerWidth > 768 && // Apply only for large screens (adjust breakpoint as needed)
                                //      (((toggle === 1 || toggle === 2) && (id === 1 || id === 2))
                                //          )
                                //          ? "260px"
                                //          : "0",
                             }}
                         >
                                {/* Clickable Title */}
                                <div
                                    className="p-3 rounded cursor-pointer d-flex justify-content-between align-items-center bg-light"
                                    onClick={() => updateToggle(id)}  // Enable toggle for all items, including id: 1
                                    style={{
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",  // Apply same box shadow to all items
                                        width: "100%",
                                        position: "relative",  // Set the title position to relative
                                        zIndex: 1,  // Ensure title stays on top of the expanded description
                                    }}
                                >
                                    <span
                                        className="fw-bold"
                                        style={{
                                            fontFamily: "Roboto",
                                            textAlign: "center",
                                            fontSize: "20px",
                                            color: "#000",  // Apply the same color to all items
                                            fontFamily: '"Helvetica Neue", Arial, sans-serif',
                                        }}
                                    >
                                        {title}
                                    </span>
                                    <span style={{ fontSize: "20px" }}>
                                        {toggle === id ? "-" : "+"} {/* Toggle + or - */}
                                    </span>
                                </div>

                                {/* Conditionally Render Description Below When Clicked */}
                                {toggle === id && (
                                    <div className="p-3 mt-2 bg-light rounded" style={{ width: "100%", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <span dangerouslySetInnerHTML={{ __html: description }} />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Dot Navigation for 3 Tabs */}

        </div>
    );
};

export default DoucmentEnergytabtwo;
